import React from 'react';
import { Button, COLORS } from 'pvs-design-system';
import { Box, Stack } from '@mui/material';
import SwapHoriz from '@mui/icons-material/SwapHoriz';
import { switchToClassic } from 'utils/viewPreference';

interface LibraryHeaderProps {
  tourCompleted: boolean;
  onTour: () => void;
}

const TourIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const LibraryHeader: React.FC<LibraryHeaderProps> = ({
  tourCompleted,
  onTour,
}) => (
  <Stack
    direction="row"
    alignItems="center"
    gap={1.5}
    sx={{
      px: 3,
      py: 1,
      borderBottom: `1px solid ${COLORS.gray[200]}`,
      flexShrink: 0,
      background: COLORS.white,
      position: 'sticky',
      top: 0,
      zIndex: 10,
    }}
  >
    {/* Utility buttons — always right-aligned */}
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={{
        flexShrink: 0,
        ml: 'auto',
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <Button
          variant="text"
          size="medium"
          onClick={onTour}
          aria-label={tourCompleted ? 'Open guided tour' : 'Open guided tour, not yet completed'}
          id="vl-guided-tour-btn"
          startIcon={<TourIcon />}
          sx={{ textTransform: 'none' }}
        >
          Guided Tour
        </Button>
        {!tourCompleted && (
          <Box
            aria-hidden="true"
            sx={{
              position: 'absolute', top: 5, right: 5,
              width: 7, height: 7, borderRadius: '50%',
              bgcolor: COLORS.purple[700], pointerEvents: 'none',
            }}
          />
        )}
      </Box>

      <Button
        color="secondary"
        size="medium"
        onClick={() => switchToClassic()}
        aria-label="Switch to classic view"
        id="vl-classic-view-btn"
        startIcon={<SwapHoriz sx={{ fontSize: 16 }} />}
        sx={{ textTransform: 'none' }}
      >
        Classic View
      </Button>
    </Stack>
  </Stack>
);

export default LibraryHeader;
